export default `float i,g,e,R=1.,S;
    vec3 q=p;
    for(int j=0;j++<9;)
      p-=clamp(p,-1.,1.)*2.,
      S=6.*clamp(.2/min(dot(p,p),7.),0.,1.),
      p=p*S+q*.7,  R=R*abs(S)+.7;
    return length(p)/R;
  }`